
import DynamicCatalogAddButton from './components/DynamicCatalogAddButton'

export default {
  install(Vue) {
    Vue.component('DynamicCatalogAddButton', DynamicCatalogAddButton)
  }
}
